var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded pl-4 pr-4 pt-1 pb-1 text-white text-center",class:_vm.getCustomClasses},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }